import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { es, ca, eu } from 'date-fns/locale';

// Spanish translations
import esCommon from '../locales/es/common.json';
import esAuth from '../locales/es/auth.json';
import esAaff from '../locales/es/aaff.json';
import esProperties from '../locales/es/properties.json';
import esSuppliers from '../locales/es/suppliers.json';
import esErrors from '../locales/es/errors.json';
import esValidation from '../locales/es/validation.json';
import esNav from '../locales/es/nav.json';
import esPdfs from '../locales/es/pdfs.json';
import esQr from '../locales/es/qr.json';

// Catalan translations
import caCommon from '../locales/ca/common.json';
import caAuth from '../locales/ca/auth.json';
import caAaff from '../locales/ca/aaff.json';
import caProperties from '../locales/ca/properties.json';
import caSuppliers from '../locales/ca/suppliers.json';
import caErrors from '../locales/ca/errors.json';
import caValidation from '../locales/ca/validation.json';
import caNav from '../locales/ca/nav.json';
import caPdfs from '../locales/ca/pdfs.json';
import caQr from '../locales/ca/qr.json';

// Basque translations
import euCommon from '../locales/eu/common.json';
import euAuth from '../locales/eu/auth.json';
import euAaff from '../locales/eu/aaff.json';
import euProperties from '../locales/eu/properties.json';
import euSuppliers from '../locales/eu/suppliers.json';
import euErrors from '../locales/eu/errors.json';
import euValidation from '../locales/eu/validation.json';
import euNav from '../locales/eu/nav.json';
import euPdfs from '../locales/eu/pdfs.json';
import euQr from '../locales/eu/qr.json';

// Map i18n language to date-fns locale
const dateLocales = { es, ca, eu };

export const getDateLocale = () => {
  const lang = i18n.language || 'es';
  return dateLocales[lang] || es;
};

const resources = {
  es: {
    common: esCommon,
    auth: esAuth,
    aaff: esAaff,
    properties: esProperties,
    suppliers: esSuppliers,
    errors: esErrors,
    validation: esValidation,
    nav: esNav,
    pdfs: esPdfs,
    qr: esQr,
  },
  ca: {
    common: caCommon,
    auth: caAuth,
    aaff: caAaff,
    properties: caProperties,
    suppliers: caSuppliers,
    errors: caErrors,
    validation: caValidation,
    nav: caNav,
    pdfs: caPdfs,
    qr: caQr,
  },
  eu: {
    common: euCommon,
    auth: euAuth,
    aaff: euAaff,
    properties: euProperties,
    suppliers: euSuppliers,
    errors: euErrors,
    validation: euValidation,
    nav: euNav,
    pdfs: euPdfs,
    qr: euQr,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',
    defaultNS: 'common',
    ns: ['common', 'auth', 'aaff', 'properties', 'suppliers', 'errors', 'validation', 'nav', 'pdfs', 'qr'],

    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false, // React already escapes
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
